import React from 'react';
import { NavLink } from 'react-router-dom';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';

const AccountSidebar = () => (
  <div className="AccountSidebar">
    <ul className="nav flex-column">
      <li className="nav-item">
        <NavLink to="/account" exact activeClassName="active" className="nav-link">
          <FontAwesomeIcon icon={["far", "home"]} />
          <span>Business</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/account/users" exact activeClassName="active" className="nav-link">
          <FontAwesomeIcon icon={["far", "users"]} />
          <span>Users</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/account/devices" exact activeClassName="active" className="nav-link">
          <FontAwesomeIcon icon={["far", "hdd"]} />
          <span>Devices</span>
        </NavLink>
      </li>
      <li className="nav-item">
        <NavLink to="/account/reminders" exact activeClassName="active" className="nav-link">
          <FontAwesomeIcon icon={["far", "bell"]} />
          <span>Reminders</span>
        </NavLink>
      </li>

      <li className="nav-item">
        <NavLink to="/account/report-settings" exact activeClassName="active" className="nav-link">
          <FontAwesomeIcon icon={["far", "file-alt"]} />
          <span>Reports</span>
        </NavLink>
      </li>
    </ul>
  </div>
)

export default AccountSidebar;



// WEBPACK FOOTER //
// ./src/features/Account/AccountSidebar/AccountSidebar.js